// extracted by mini-css-extract-plugin
export default {"modalInputContainer":"modals_modalInputContainer__KsQ6+"};